export default __webpack_public_path__ + "static/media/spaceship.6b306a8e.svg";